<template>
  <div class="power-off-container">
    <svg
      class="power-off-icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M18.36 6.64a9 9 0 1 1-12.73 0"></path>
      <line x1="12" y1="2" x2="12" y2="12"></line>
    </svg>
  </div>
</template>

<script setup lang="ts">
// Power-Off Logo Component
</script>

<style scoped>
.power-off-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.power-off-icon {
  width: 24px;
  height: 24px;
  color: inherit;
  transition: transform 0.2s ease, color 0.2s ease;
}

.power-off-icon:hover {
  transform: scale(1.1);
}
</style>
